import { z } from 'zod';
import { messages } from '@/config/messages';

// form zod validation schema
export const ServiceFormSchema = z.object(
  {
    id: z.string().optional(),
    name: z.string().nonempty({ message: messages.nameIsRequired }),
    subTitle: z.string().nonempty({ message: messages.subTitleIsRequired }),
    description: z.string().nonempty({ message: messages.descriptionIsRequired }),
    image: z.string().optional(),
    icon: z.string().optional(),
    createdDate: z.string().optional(),
    createdUser: z.string().optional(),
  },
);

// generate form types from zod validation schema
export type CreateServiceInput = z.infer<typeof ServiceFormSchema>;
